<div *ngIf="!isNewClient">
  <div class="content-with-filled-button">
    <div class="box_title">
      <h1 class="title" id="productsTitle">
        {{channelCommunicatorService.getChannelId() !== '159' ?
        copyService.copies.product_selection_title:copyService.copies.request_title}}
      </h1>
      <p class="sub-title" id="productsSubtitle">
        {{channelCommunicatorService.getChannelId() !== '159' ?
        copyService.copies.product_selection_subtitle:copyService.copies.request_Subtitle}}
      </p>
    </div>
    <div class="main row">
      <div class="col-pr-12 col-sm-6 col-md-6 col-lg-4 mt-4" *ngFor="let product of products">
        <div class="products" *ngIf="product.active" [id]="helper.parseCamelCaseForIds(product.name, false)">
          <vcl-card-template [title]="product.es" [paragraph]="product.description"
            image="{{product.image ? 'assets/images/' + product.image : ''}}" showButtons="true"
            buttonAlignment="vertical" [primaryFirst]="false"
            [labelButtons]="{primary: product.button ? product.button : copyService.copies.product_selection_go_ahead, secondary: copyService.copies.product_selection_product_detail}"
            (clickPrimary)="goAhead(product)"
            (clickSecondary)="goToProductDetails(product, 'ConoceMas')"></vcl-card-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isNewClient">
  <div class="principalCard">
    <div id="mainCard" class="voxel-card">
      <div class="contentCard">
        <h2 class="voxel-text-section-02 voxel-mb-2">
          ¡Abre tu cuenta de ahorros Itaú!
        </h2>
        <br>
        <!-- <vcl-list>
          <li *ngFor="let benefit of copyService.copies.new_client.saving_account.benefits" vclListSimple>
            <vcl-list-text id="itemBenefits">
              {{ benefit }}
            </vcl-list-text>
          </li>
        </vcl-list> -->
        <li>Sin cuota de manejo</li>
        <li>Retiros sin costo</li>
        <li>Transferencias gratis con tu número de celular</li>
        <li>Compras en línea</li>
        <br>
        <p class="voxel-text-body-01">
          *Aplican términos y condiciones.
        </p>
        <button voxelButton class="voxel-mt-4" id="nextButton" (click)="goAhead(principalProduct)">Solicitar</button>
      </div>
    </div>
  </div>
  <br>
  <div class="otherProducts">
    <h2><strong>Más productos</strong></h2>
    <div class="products">
      <div class="option">
        <ul class="botton-line">
          <vcl-list>
            <li class="optionProduct" vclListAction (click)="goAhead(products[0])">
              <vcl-list-text>
                <span id="iconProduct" class="icon icon-itaufonts_cartao"></span>
                Productos de crédito
                <div class="widget"> 
                  <div class="widget-estrela">
                    <span id="iconEstrela" class="icon icon-itaufonts_estrela"></span>
                    <span>Para ti</span>
                  </div>
                </div>
              </vcl-list-text>
            </li>
            <li class="optionProduct" vclListAction (click)="goAhead(products[2])">
              <vcl-list-text>
                <span id="iconProduct" class="icon icon-itaufonts_comprovante"></span>
                Cuenta de nómina
              </vcl-list-text>
            </li>
            <div class="line"></div>
            <li class="optionProduct" vclListAction (click)="goAhead(products[3])">
              <vcl-list-text>
                <span id="iconProduct" class="icon icon-itaufonts_consorcio_imobiliario"></span>
                Crédito de vivienda
              </vcl-list-text>
            </li>
          </vcl-list>
          <div class="line"></div>
        </ul>
      </div>
    </div>
  </div>
  <br>
  <div class="other">
    <h2><strong>Otros</strong></h2>
    <div class="products">
      <ul class="botton-line">
        <vcl-list>
          <li *ngFor="let product of otherOptions" vclListAction (click)="goAhead(product)">
            <vcl-list-text>
              <span id="iconProduct" class="icon icon-itaufonts_busca_consulta"></span>
              Consulta tus solicitudes
            </vcl-list-text>
          </li>
        </vcl-list>
        <div class="line"></div>
      </ul>
    </div>
  </div>
</div>